import styled from "@emotion/styled";
import React from "react";
import UI from "@mile-meeting/mile-ui";

type MainPolicySettingBlockProps = {
  title?: string;
  description?: string;
  tagLabel?: string;
  showTag?: boolean;
  tagType?: "primary" | "secondary";
  rightChildren?: React.ReactNode;
  haveChildren?: boolean;
  showBorderTop?: boolean;
  showAdvancedSettings?: boolean;
  disabledAdvancedSettings?: boolean;
  onClickAdvancedSettings?: () => void;
};
const MainPolicySettingBlock: React.FC<MainPolicySettingBlockProps> = ({
  title,
  description,
  tagLabel,
  tagType = "primary",
  showTag = false,
  rightChildren = <></>,
  haveChildren = false,
  showBorderTop = false,
  showAdvancedSettings = false,
  disabledAdvancedSettings = false,
  onClickAdvancedSettings = () => {},
}) => {
  return (
    <Container
      style={{
        padding: haveChildren ? "20px 28px 12px 40px" : "20px 28px 20px 40px",
        borderTop: showBorderTop ? "2px solid var(--alias-color-line-alternative)" : "none",
      }}
    >
      <LeftSideContainer>
        <Title>
          <UI.Typography type="body01 normal" fontStyle="bold" color="var(--alias-color-label-normal)">
            {title}
          </UI.Typography>
          {showTag && <UI.Tag label={tagLabel} size="small" color="blue" type={tagType} />}
        </Title>
        <UI.Typography type="body02 normal" fontStyle="medium" color="var(--alias-color-label-alternative)">
          {description}
        </UI.Typography>
      </LeftSideContainer>
      <RightSideContainer>
        {rightChildren && rightChildren}
        {showAdvancedSettings && (
          <UI.ButtonGroups.Text
            disabled={disabledAdvancedSettings}
            title="회의실별 상세 설정"
            size="small"
            onClick={onClickAdvancedSettings}
            suffixIcon="setting"
            showSuffixIcon
            type="secondary"
          />
        )}
      </RightSideContainer>
    </Container>
  );
};

export default React.memo(MainPolicySettingBlock);

const Container = styled.div`
  display: flex;
  padding: 20px 28px 12px 40px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const LeftSideContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
`;

const Title = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

const RightSideContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 8px;
`;
